import { render, staticRenderFns } from "./UserMapping.vue?vue&type=template&id=19c2ec1b&lang=pug&"
import script from "./UserMapping.vue?vue&type=script&lang=js&"
export * from "./UserMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports